/**
 * The city's search URL, /deals/amsterdam/zoeken/sushi/, in its own language. The page
 * names it on #tweakwise-wrapper with a placeholder for the term.
 */
const PLACEHOLDER = '__query__';

function template(): string | null {
  const url = document.getElementById('tweakwise-wrapper')?.dataset.searchUrl;

  return url ? new URL(url, window.location.href).pathname : null;
}

/**
 * The term as its URL segment, as SearchQuery::getSlug() makes it but for the letters it
 * transliterates: "smørrebrød" stays itself here, and the page redirects it to its ASCII
 * form when it is opened, rather than losing the ø to a guess.
 */
export function searchSlug(value: string): string {
  return value
    .replace(/[^\p{L}\d.]+/gu, '-')
    .replace(/^-+|-+$/g, '')
    .toLowerCase();
}

export function searchPath(value: string): string | null {
  const path = template();
  const slug = searchSlug(value);

  return path && slug ? path.replace(PLACEHOLDER, encodeURIComponent(slug)) : null;
}

/** The term a search URL names, read back as SearchQuery::fromSlug() does. */
export function searchTermFromUrl(url: URL): string | null {
  if (url.searchParams.has('q')) {
    return url.searchParams.get('q');
  }
  const path = template();
  if (!path) {
    return null;
  }
  const [before, after] = path.split(PLACEHOLDER);
  if (!url.pathname.startsWith(before) || !url.pathname.endsWith(after)) {
    return null;
  }
  const segment = url.pathname.slice(before.length, url.pathname.length - after.length);

  return segment && !segment.includes('/') ? decodeURIComponent(segment).replace(/-/g, ' ') : null;
}

/** The listing a search runs on, where clearing it goes back to. */
export function searchListingPath(): string | null {
  const path = template();

  return path ? path.split(PLACEHOLDER)[0].replace(/[^/]+\/$/, '') : null;
}
